import DataBlocksList from "@/features/datablocks/list";

const Evidence = () => {
  return <DataBlocksList />;
};

export default Evidence;
